module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAdBAMAAADWchiKAAAALVBMVEU0hf8AAAA0hf80hf80hf80hf80hf80hf80hf80hf80hf80hf80hf80hf80hf+/aF6YAAAAD3RSTlNNAARHOBotCD4hMxMMHiYIuUroAAAAtElEQVQoz93OwQnCQBAF0A8RRBHZiYgiBoIVbAlBtgDtwBaClxxTgooHjzl5z0U8xlK0Ev/Mmib8l/28HYbBJkYkjSXHAZa9zBDzt3INIXiVFUuhIkyjonG98Ks1yQFvUvfS/SQFUJrsgFplDiQGurBRWQIDgzWAkwpPGplUlI7y5DtUyDyHHRY3MG/Cg4CJQ6Zga+zgs4OVrcoRuo/CMhUNp5OWwjIuxVIkH1GR+0tiqotQvvInK/zUnWjnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/symbol2.png
// module id = THhc
// module chunks = 0